import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, [
  /*#__PURE__*/_createTextVNode(" ご予約の変更・キャンセルは、 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" お電話もしくはLINEにてご連絡ください。 ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { computed } from "vue";
import { useStore } from "vuex";
import { SHOW_BOOKING_MESSAGE_CLINICS } from "../constants/clinic.constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingMessage',
  setup(__props) {

const store = useStore();

/**
 * 特定のクリニックIDの場合にのみメッセージを表示するかどうかを判定する
 *
 * @returns {boolean} メッセージ表示対象のクリニックIDの場合はtrue
 */
const shouldShowMessage = computed(() => {
  const clinicId = store.getters["line_account/clinicId"];
  return SHOW_BOOKING_MESSAGE_CLINICS.includes(clinicId);
});

return (_ctx: any,_cache: any) => {
  return (_unref(shouldShowMessage))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})